// External dependencies.
import $ from "jquery";

/**
 * ProductQuantityInput class.
 *
 * @since 0.7.0
 * @class ProductQuantityInput
 */
class ProductQuantityInput {
    /**
     * Creates an instance of ProductQuantityInput.
     * 
     * @since 0.7.0
     * @memberof ProductQuantityInput
     */
    constructor() {
        this.minBtn = document.querySelectorAll( '.js-product-min-btn' );
        this.maxBtn = document.querySelectorAll( '.js-product-max-btn' );
        this.input = null;
        this.theInput = ( "1" === window.app.is_product ) ? document.querySelector( 'input[name="quantity"]' ) : null;
        this.events = this.events.bind( this );
        this.dispatchProductQuantiyChangedEvent = this.dispatchProductQuantiyChangedEvent.bind( this );
        this.minQuantity = this.minQuantity.bind( this );
        this.maxQuantity = this.maxQuantity.bind( this );

        this.events();
    }

    /**
     * Listens for events.
     *
     * @since 0.7.0
     * @since 0.14.1 Added a listener for the input event.
     * @listens event:click
     * @listens event:input
     * @memberof ProductQuantityInput
     */
    events() {
        !!this.minBtn.length && this.minBtn.forEach( elem => {
            elem.addEventListener( 'click', this.minQuantity );
        } );

        !!this.maxBtn.length && this.maxBtn.forEach( elem => {
            elem.addEventListener( 'click', this.maxQuantity );
        } );

        this.theInput && this.theInput.addEventListener( 'input', this.dispatchProductQuantiyChangedEvent );
    }

    /**
     * Sets up data and dispatches the productQuantityChanged custom event.
     *
     * @since 0.14.1
     * @memberof ProductQuantityInput
     */
    dispatchProductQuantiyChangedEvent() {
        const qty = this.theInput.value;
        let mix_and_match_data = [];

        if ( 'mix-and-match' === window.app.product.type ) {
            const mixAndMatchItems = document.querySelectorAll( '.mnm_item' );
            !!mixAndMatchItems.length && mixAndMatchItems.forEach( item => {
                const input = item.querySelector( 'input[type="number"]' );

                if ( input ) {
                    const value = input.value;
                    mix_and_match_data.push( {
                        qty: parseInt( value ),
                        price: parseFloat( item.getAttribute( 'data-price' ) ),
                        regular_price: parseFloat( item.getAttribute( 'data-regular_price' ) ),
                    } );
                }
            } );
        }

        document.dispatchEvent( new CustomEvent( 'productQuantityChanged', { detail: { qty, mix_and_match_data } } ) );
    }

    /**
     * Sets the input min value.
     *
     * @since 0.7.0
     * @since 0.14.1 Calls the dispatchProductQuantiyChangedEvent function.
     * @param object e
     * @memberof ProductQuantityInput
     */
    minQuantity( e ) {
        e.preventDefault();
        const inputID = e.target.closest( '.js-product-min-btn' ).getAttribute( 'data-target' );
        this.input = document.querySelector( inputID );
        let min = parseInt( this.input.getAttribute( 'min' ) );
        let currentValue = parseInt( this.input.value );
        let newValue = null;

        min = ( isNaN( min ) ) ? 1 : min;

        if ( currentValue <= min ) {
            newValue = min;
        }

        if ( currentValue > min ) {
            newValue = --currentValue;
        }

        this.input.value = newValue;
        $( this.input ).trigger( 'change' );

        if ( "1" === window.app.is_product ) {
            this.dispatchProductQuantiyChangedEvent();
        }
    }

    /**
     * Sets the input max value.
     *
     * @since 0.7.0
     * @since 0.14.1 Calls the dispatchProductQuantiyChangedEvent function.
     * @emits event:productQuantityChanged
     * @param object e
     * @memberof ProductQuantityInput
     */
    maxQuantity( e ) {
        e.preventDefault();
        const inputID = e.target.closest( '.js-product-max-btn' ).getAttribute( 'data-target' );
        this.input = document.querySelector( inputID );
        let max = parseInt( this.input.getAttribute( 'max' ) );
        let currentValue = parseInt( this.input.value );
        let newValue = null;

        max = ( isNaN( max ) ) ? Infinity : max;

        if ( currentValue >= max ) {
            newValue = max;
        }

        if ( currentValue < max ) {
            newValue = ++currentValue;
        }

        this.input.value = newValue;
        $( this.input ).trigger( 'change' );

        if ( "1" === window.app.is_product ) {
            this.dispatchProductQuantiyChangedEvent();
        }
    }
}

export default ProductQuantityInput;
